import React from 'react';

const Disclaimer = () => (
    <p className="disclaimer">
        All capacities are a guideline only and are based on the maximum use of the space available for standard setups. They may be reduced by staging, technical equipment, catering or entertainment.
    </p>
);

export default Disclaimer;
